/**
 * UserAnalyticsView ID から Project ID を復元します。
 * ID 形式: UserAnalyticsView:customers/{org}/projects/{project}/...
 * @param viewId Base64 エンコードされたビューID
 * @returns Base64 エンコード済み Project ID（失敗時は null）
 */
export function toProjectIdFromUaViewId(viewId: string): string | null {
  try {
    const decoded = atob(viewId);
    const parts = decoded.split("/");
    const orgDb = parts[1];
    const projectDb = parts[3];
    if (!orgDb || !projectDb) return null;
    const rawProject = `Project:customers/${orgDb}/projects/${projectDb}`;
    return btoa(rawProject);
  } catch {
    return null;
  }
}
